<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./Technology.translations.json";
	import aboutTranslations from "../components/About/TechnologyAbout.translations.json";
	import HeroBanner from "../components/HeroBanner.svelte";
	import TechnologyBanners from "../components/TechnologyBanners.svelte";
	import ProductGroups from "../components/ProductGroups.svelte";
	import carFooterBanner from "../assets/images/car-footer-banner.png?webp&w=1920&imagetools";
	import technologyHeader from "../assets/videos/brano-technologies-header.mp4";
	import technologyPoster from "../assets/videos/brano-technologies-header.jpg?webp&w=1920&imagetools";
	import technologyHeaderMobile from "../assets/videos/brano-technologies-header-mobile.mp4";
	import { getContext } from "svelte";
	import { productGroupsContextKey } from "../contexts/productGroupsContextKey.js";
	import type { ProductGroupWithTextifiedContent } from "../../../core/schema/ProductGroup.js";
	import About from "../components/About/About.svelte";

	const translate = getTranslate(translations);

	const productGroups = getContext<ProductGroupWithTextifiedContent[]>(productGroupsContextKey);
</script>

<Layout
	menuTextColor="text-secondary"
	largeFooterImage
	footerImage={carFooterBanner}
	footerImageClass="max-lg:object-[80%_center]"
>
	<HeroBanner
		title={translate("heading")}
		backgroundVideo={technologyHeader}
		backgroundVideoMobile={technologyHeaderMobile}
		videoPoster={technologyPoster}
		overlay="black"
		linkText={translate("showMore")}
	/>

	<section>
		<About translations={aboutTranslations} />
	</section>

	<section class="bg-tertiary">
		<TechnologyBanners />
	</section>

	<section class="container mt-[5rem] lg:mt-[15rem]">
		<div class="border-tertiary-300 container border-b py-8">
			<span class="text-[2rem] font-normal leading-[1.18] lg:text-[2.375rem]">{translate("whereNext")}</span>
			<h3 class="text-[2.75rem] font-semibold leading-[3.125rem] lg:text-[4.625rem] lg:leading-[5.25rem]">
				{translate("discoverHeadline")}
			</h3>
		</div>
		<ProductGroups {productGroups} topOffset={false} />
	</section>
</Layout>
